<template>
  <router-link
    :to="{name: 'win_streak_info', params: {winStreakId: winStreakId}}"
  >
    {{lable}} {{winStreakId}}
  </router-link>
</template>

<script>
export default {
  name: 'WinStreakLink',

  props: {
    winStreakId: {
      type: Number,
      required: true,
    },

    lable: {
      type: String,
      default: 'Win streak',
    },
  },
};
</script>
